/* eslint-disable @typescript-eslint/no-require-imports */
const path = require('path');

/**
 * @type {import('next-i18next/pages').UserConfig}
 */
module.exports = {
  i18n: {
    defaultLocale: 'en',
    locales: ['de', 'en', 'es', 'nl'],
    localeDetection: false, // prevents auto-redirects to /nl/..., /en/..., /de/...
  },
  // Use path.resolve to ensure the server finds the folder regardless of execution context
  localePath: path.resolve('./src/translations'),
  reloadOnPrerender: process.env.NODE_ENV === 'development',
};
